import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Fetch, daysSince } from '../../utils/Utils.js';
import LotDetail, { StatCard, formatLotCode } from '../../shared/lots/LotDetail.js';
import DetailWhatsAppTip from '../../shared/DetailWhatsAppTip.js';
import { reproLotTips } from '../../shared/whatsappTips.js';

export const ReproLotDetail = () => {
  const { lotId } = useParams();
  const { t }     = useTranslation();
  const [lot,        setLot]        = useState(null);
  const [protocols,  setProtocols]  = useState([]);
  const [bulls,      setBulls]      = useState([]);
  const [assignment, setAssignment] = useState(null); // null=loading, false=none

  useEffect(() => {
    Fetch(`api/data/lots?search_fields=type,lot_id&search_values=reproduction,${lotId}`, 'get', null,
      (data) => setLot((data || [])[0] || null)
    );
    Fetch('api/data/lots.plans', 'get', null, (data) => setProtocols(data || []));
    Fetch('api/data/reproduction.bulls',     'get', null, (data) => setBulls(data || []));
    // protocol_id/start_date/bull_id all live on the active assignment now,
    // not cached on the lot doc — see protocol_assignments.Assign.
    Fetch(`api/lots/${lotId}/assignment`, 'GET', null,
      (data) => setAssignment(data || false),
      ()     => setAssignment(false)
    );
  }, [lotId]);

  if (!lot) return <div className="wl-empty-note" style={{ padding: 24 }}>…</div>;

  const protocol    = assignment ? protocols.find(p => p._id === assignment.protocol_id) : null;
  const bull        = assignment ? bulls.find(b => b._id === assignment.bull_id) : null;
  const currentDay  = assignment && assignment.start_date ? daysSince(assignment.start_date) : null;

  const stats = (
    <>
      {protocol   && <StatCard label={t('protocol_name')} value={protocol.name} />}
      {assignment && assignment.start_date && <StatCard label={t('start_date')} value={assignment.start_date} />}
      {bull       && <StatCard label={t('bull')}          value={bull.name} />}
      {currentDay != null && <StatCard label={t('current_day')}  value={`${t('day')} ${currentDay}`} />}
    </>
  );

  return (
    <LotDetail
      lot={lot}
      prefix={t('lot_prefix')}
      basePath="/reproduction/lots"
      onFieldSaved={(field, value) => setLot(prev => ({ ...prev, [field]: value }))}
      stats={stats}
      animalsTo="/reproduction/animals"
      animalsState={{ lotFilter: lot.lot_id }}
      whatsappTip={<DetailWhatsAppTip title={t('lot_tip_title')}
        tips={reproLotTips(formatLotCode(lot.lot_id, t('lot_prefix')), t)} />}
    />
  );
};

export default ReproLotDetail;
